var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Celo_Logotype",
    "data-name": "Celo Logotype",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3952 1575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3338;}.cls-2{fill:#fbcc5c;}.cls-3{fill:#35d07f;}.cls-4{fill:#5ea33b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Type",
    className: "cls-1",
    d: "M2817,1089l86-27V350l-86,27ZM1825,657c54,0,104,24,136,64l35-81c-46-44-107-65-171-65-148,0-250,117-249,246,1,140,111,254,249,254,70,0,123-21,163-50V926c-42,42-103,67-156,67-80,0-170-65-170-172C1662,722,1740,657,1825,657Zm572-82c-148,0-234,117-234,246,0,140,111,254,249,254,70,0,123-21,163-50V926c-42,42-103,67-156,67-71,0-149-44-165-137h377V823C2631,685,2540,575,2397,575Zm929,0c-138,0-250,112-250,250s112,250,250,250,250-112,250-250S3464,575,3326,575Zm-928,82c67,0,138,42,144,123H2254C2260,699,2331,657,2398,657Zm928,336a168,168,0,1,1,168-168A167.72,167.72,0,0,1,3326,993Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Bottom_Ring",
    "data-name": "Bottom Ring",
    className: "cls-2",
    d: "M751,1100c151.88,0,275-123.12,275-275S902.88,550,751,550,476,673.12,476,825,599.12,1100,751,1100Zm0,100c-207.1,0-375-167.9-375-375S543.9,450,751,450s375,167.9,375,375S958.1,1200,751,1200Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Top_Ring",
    "data-name": "Top Ring",
    className: "cls-3",
    d: "M951,900c151.88,0,275-123.12,275-275S1102.88,350,951,350,676,473.12,676,625,799.12,900,951,900Zm0,100c-207.1,0-375-167.9-375-375S743.9,250,951,250s375,167.9,375,375S1158.1,1000,951,1000Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rings_Overlap",
    "data-name": "Rings Overlap",
    className: "cls-4",
    d: "M963.3,999.8a274.13,274.13,0,0,0,54.52-108,274.18,274.18,0,0,0,108-54.51,373.33,373.33,0,0,1-29.14,133.35A373.33,373.33,0,0,1,963.31,999.8ZM684.19,558.18a274.18,274.18,0,0,0-108,54.51,373.33,373.33,0,0,1,29.14-133.35A373.33,373.33,0,0,1,738.7,450.2,274.18,274.18,0,0,0,684.19,558.18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelo);
export default __webpack_public_path__ + "static/media/celo.4f70cf07e86515467ddd3c05880a79ba.svg";
export { ForwardRef as ReactComponent };